import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';

interface SettingsPageHeaderProps {
  title: string;
  meta?: ReactNode;
  actions?: ReactNode;
}

export function SettingsPageHeader({ title, meta, actions }: SettingsPageHeaderProps) {
  return (
    <>
      <div className="flex min-w-0 items-center gap-5">
        <div className="flex min-w-0 items-center gap-3">
          <Link
            to="/dashboard/settings"
            className="hidden text-xs text-[#737373] transition-colors hover:text-foreground sm:inline"
          >
            Settings
          </Link>
          <span className="hidden text-[#aaa] sm:inline">›</span>
          <h1 className="truncate text-[17px] font-semibold tracking-[-0.01em]">{title}</h1>
        </div>
        {meta}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </>
  );
}
